import React from 'react';
import { useDialog, useSnackbar } from '@ianesthesie-kit/redux';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { TranslatedText, useTranslator } from '@ianesthesie-kit/core';
import { PushNotificationService } from '@/modules/notification';
import { useIsVerified } from '@/modules/userConfig';
import { useAppDispatch } from '@/hooks';
import { postponePushPermission } from '@/modules/ui';
import { StandardDialogContainer } from './common';

export const PushNotificationDialog = () => {
  const { closeDialog } = useDialog();
  const { showSnackbar } = useSnackbar();
  const translate = useTranslator();
  const dispatch = useAppDispatch();
  const userVerified = useIsVerified();

  const closeAndRequestPermission = () => {
    PushNotificationService.getInstance()
      .subscribeIfNotSubscribed()
      .then(closeDialog)
      .then(() => {
        showSnackbar({
          severity: 'success',
          message: translate('patient-app.grantPushPermissionSuccessSnackbar'),
          position: {
            horizontal: 'center',
            vertical: 'top'
          }
        });
      })
      .catch(closeDialog);
  };

  const closeAndPostpone = () => {
    dispatch(postponePushPermission()).finally(closeDialog);
  };

  if (!userVerified) {
    closeDialog();
    return null;
  }

  return (
    <StandardDialogContainer>
      <DialogTitle>
        <TranslatedText id="patient-app.pushNotifications.dialogTitle" />
      </DialogTitle>
      <DialogContent sx={{ position: 'relative', minHeight: 80 }}>
        <DialogContentText>
          <TranslatedText id="patient-app.pushNotifications.dialogBody" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={closeAndPostpone}>
          <TranslatedText id="patient-app.pushNotifications.dialogCancel" />
        </Button>
        <Button onClick={closeAndRequestPermission}>
          <TranslatedText id="app.enable" />
        </Button>
      </DialogActions>
    </StandardDialogContainer>
  );
};
